import * as React from 'react'
import {useEffect} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../lib/MobXProvider'
import {WidgetApi} from '../../../lib/WidgetApi'
import {IconSpinner} from '../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const SpinnerOuterBlock = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const spinnerText = api.trans('spinner_submitting', {defaultValue: null})

  useEffect(() => {
    document.body.classList.add('overflow-hidden')

    return () => document.body.classList.remove('overflow-hidden')
  }, [])

  return (
    <div className="spinner-outer-block">
      {spinnerText && (
        <span className="sr-only" role="status" aria-live="assertive">
          {spinnerText}
        </span>
      )}
      <IconSpinner />
    </div>
  )
})
